const state = {
  userId:'',
  email:"",
  password:''
}

export default state
